import type { RoutePathOption } from "@gpx-spa/geo-domain";

function formatDuration(totalSeconds: number): string {
  if (totalSeconds < 3600) {
    return `${Math.max(1, Math.round(totalSeconds / 60))} min`;
  }
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.round((totalSeconds % 3600) / 60);
  return m > 0 ? `${h} h ${m} min` : `${h} h`;
}

export function formatPathLabel(path: RoutePathOption): string {
  const dm = path.meta?.distance_m;
  const ds = path.meta?.duration_s;
  const dist =
    dm != null
      ? `${dm >= 10000 ? (dm / 1000).toFixed(0) : (dm / 1000).toFixed(1)} km`
      : "—";
  const dur = ds != null ? formatDuration(ds) : "—";
  const sampleCount = path.meta?.sample_count;
  if (
    path.meta?.provider === "learned" &&
    typeof sampleCount === "number" &&
    Number.isFinite(sampleCount)
  ) {
    const shipmentLabel =
      sampleCount === 1 ? "1 shipment" : `${sampleCount} shipments`;
    return `${dist} · ${dur} · ${shipmentLabel}`;
  }
  return `${dist} · ${dur}`;
}
